<div class="row d">
  <div class="col-lg-7">
    <div class="d-md-flex">
      <div class="m-b-10 m-r-20">
        <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
          <input
            type="text"
            nz-input
            placeholder="Search"
            (keyup)="onKeyUp(searchBox.value)"
            [(ngModel)]="searchTerm"
            #searchBox
          />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <a nz-icon class="opacity-05" (click)="resetSearch()">
            <i nz-icon nzType="close" class="opacity-05"></i>
          </a>
        </ng-template>
        <ng-template #prefixTemplate>
          <i nz-icon nzType="search" class="opacity-05"></i>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="col-lg-5">
    <div class="d-md-flex justify-content-end">
      <!-- <div class="m-b-10 m-r-20">
        <button
          nz-button
          nz-popover
          nz-popover
          nzPopoverTrigger="click"
          nzPopoverPlacement="bottom"
          class="btn-outline resource-btn"
          style="text-align: center"
        >
          All Courses<i
            nz-icon
            nzType="caret-down"
            style="position: relative; top: 1px; left: -3px"
            nzTheme="outline"
          ></i>
        </button>
      </div> -->
      <!-- <button
        nz-button
        nzType="default"
        nz-popover
        nzPopoverPlacement="bottomRight"
        nzPopoverTrigger="click"
        class="btn-fill"
      >
        <span>
          <i class="fa fa-plus button-plus-icon" aria-hidden="true"></i></span
        >&nbsp;NEW
      </button> -->
    </div>
  </div>
</div>

<div class="row" [@wipeOutRight]>
  <div nz-col>
    <div style="max-height: 400px; overflow-y:auto">
      <nz-table
        #academyTable
        [nzData]="courseData"
        [nzPageSize]="20"
        nzSize="small"
      >
        <thead nzSingleSort>
          <tr class="data-row cursor-move">
            <th>
              <label
                nz-checkbox
                [(nzChecked)]="allChecked"
                (nzCheckedChange)="checkAll($event)"
              ></label>
            </th>
            <ng-container *ngFor="let column of listOfColumns">
              <th
                *ngIf="column.name !== ''"
                [nzSortOrder]="column.sortOrder"
                [nzSortFn]="column.sortFn"
                [nzSortDirections]="column.sortDirections"
                [nzFilterMultiple]="column.filterMultiple"
                [nzWidth]="column.colWidth"
              >
                {{ column.name }}
              </th>
            </ng-container>
            <!-- <th nzShowSort nzSortKey="name">Courses</th>
            <th nzShowSort nzSortKey="type">Chapters</th>
            <th nzShowSort nzSortKey="members">Popularity</th>
            <th nzShowSort nzSortKey="resources">Uploaded</th>
            <th nzShowSort nzSortKey="resources">Expires</th>
            <th nzShowSort nzSortKey="resources">Tags</th>
            <th></th> -->
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-item [ngForOf]="academyTable.data">
            <tr
              style="cursor: pointer"
              (click)="displayChapters(item.id)"
              class="data-row cursor-move"
            >
              <td>
                <label
                  class="m-r-15"
                  nz-checkbox
                  [(nzChecked)]="item.checked"
                  (nzCheckedChange)="onCheckboxChange()"
                ></label>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <nz-avatar
                    [nzSize]="30"
                    nzIcon="user"
                    [nzSrc]="item.avatar"
                  ></nz-avatar>
                  <span class="m-l-10 m-b-0">{{ item.course_name }}</span>
                </div>
              </td>
              <td>{{ item.chapter_count }}</td>
              <!-- <td>
                <nz-badge
                  *ngIf="item.popularity == 'high'"
                  nzStatus="success"
                ></nz-badge>
                <nz-badge
                  *ngIf="item.popularity == 'medium'"
                  nzStatus="error"
                ></nz-badge>
                <nz-badge
                  *ngIf="item.status == 'Not enough data'"
                  nzStatus="processing"
                ></nz-badge>
                <span class="text-capitalize"></span>
              </td> -->
              <td>{{ item.uploaded_date | date: 'MM/dd/yyyy' }}</td>
              <td>{{ item.expires_date | date: 'MM/dd/yyyy' }}</td>
              <!-- <td>
                <nz-tag
                  *ngFor="let tag of item.tag_data; let i = index"
                  [nzMode]="default"
                  [nzColor]="'#ededed'"
                >
                  {{ tag.tag_name }}
                </nz-tag>
              </td> -->
              <td>
                <ng-container *ngIf="item.tag && item.tag.length > 0">
                  <ng-container
                    *ngIf="item.tag.length <= 2; else moreTags"
                  >
                    <nz-tag
                      *ngFor="let tag of item.tag.slice(0, 2)"
                      [nzMode]="default"
                      [nzColor]="'#ededed'"
                    >
                      {{ tag.tag_name }}
                    </nz-tag>
                  </ng-container>
                  <ng-template #moreTags>
                    <span *ngFor="let tag of item.tag.slice(0, 2)">
                      <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                        tag.tag_name
                      }}</nz-tag>
                    </span>

                    <span
                      nz-popover
                      [nzPopoverContent]="moreContents"
                      nzPopoverPlacement="bottom"
                      (mouseenter)="updateMoreTagsContent(item.tag)"
                      (mouseleave)="resetMoreTagsContent()"
                    >
                      <nz-tag [nzMode]="default" [nzColor]="'#ededed'"
                        >+{{ item.tag.length - 2 }} more</nz-tag
                      >
                    </span>

                    <ng-template #moreContents>
                      <span *ngFor="let tag of moreTagsContent">
                        <nz-tag
                          [nzMode]="default"
                          [nzColor]="'#ededed'"
                          >{{ tag }}</nz-tag
                        >
                      </span>
                    </ng-template>
                  </ng-template>
                </ng-container>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </nz-table>
      <!-- COURSE LISTING -->
    </div>
  </div>
</div>
